import React from "react";

import TopWrapper from "./styles/Top.style";

function Top() {
  return (
    <TopWrapper>
      <div className="layer" />
      <div className="callout">
        <h1>The Wire</h1>
        <h3>
          A real-time feed previewing every new video before it’s available & the moment it’s ready
          for licensing.
        </h3>
      </div>
    </TopWrapper>
  );
}

export default Top;
